import { useEffect, useState } from "react";
import {
  fetchProjects,
  downloadProjectsExcel,
  fetchProjectDetails,
  updateProject,
  fetchProjectsByOrg,
  fetchProjectsByTeamMember,
} from "../Api/ViewProjects";
import { getTeamsByOrg } from "../Api/TeamMaster";
import {
  Container,
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getAllProjectStatus } from "../Api/ProjectStatusApi";
import { fetchCustomerMasterByOrgId } from "../Api/ViewCustomerMaster";
import { FaDownload, FaTimes } from "react-icons/fa";
import { fetchProjectTypes } from "../Api/InvoiceApi";
import { Spinner } from "react-bootstrap";
import { useMemo } from "react";
import Select from "react-select";
import "./ViewProject.css";
import { fetchResourceByOrgId } from "../Api/InvoiceApi";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { getProjectMetaNames } from "../Api/ProjectMaster";

const ViewProjects = () => {
  const [projects, setProjects] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const navigate = useNavigate();

  const [selectedStatusFilter, setSelectedStatusFilter] = useState([]);
  const [selectedSubStatusFilter, setSelectedSubStatusFilter] = useState([]);
  const [selectedCustomerFilter, setSelectedCustomerFilter] = useState([]);
  const [selectedTypeFilter, setSelectedTypeFilter] = useState([]);
  const [selectedSalespersonFilter, setSelectedSalespersonFilter] = useState(
    [],
  );
  const [selectedProjectManagerFilter, setSelectedProjectManagerFilter] =
    useState([]);

  const [resourceMap, setResourceMap] = useState({});

  const [searchTitle, setSearchTitle] = useState("");
  const [customerMap, setCustomerMap] = useState({});
  const [customers, setCustomers] = useState([]);

  const [teams, setTeams] = useState([]);
  const [teamMap, setTeamMap] = useState({});

  // New state for meta data from the API
  const [metaDataMap, setMetaDataMap] = useState({
    type: {},
    status: {},
    substatus: {},
  });
  const [isMetaDataLoaded, setIsMetaDataLoaded] = useState(false);
  console.log("Meta Substatus Map:", metaDataMap);

  const defaultFilters = [
    "projectId",
    "status",
    "subStatus",
    "customer",
    "type",
    "salesperson",
    "manager",
    "category",
    "startDate",
    "endDate",
  ];

  const [visibleFilters, setVisibleFilters] = useState(() => {
    const saved = localStorage.getItem("projectVisibleFilters");
    return saved ? JSON.parse(saved) : defaultFilters;
  });

  // Define initial column order
  const defaultColumnOrder = [
    "index",
    "projectId",
    "title",
    "description",
    "tags",
    "startDate",
    "endDate",
    "client",
    "type",
    "team",
    "status",
    "subStatus",
    "category",
    "comments",
    "createdOn",
    "createdBy",
    "changedOn",
    "changedBy",
    "salesperson",
    "projectManager",
  ];

  const [columnOrder, setColumnOrder] = useState(() => {
    const saved = localStorage.getItem("projectColumnOrder");
    const savedOrder = saved ? JSON.parse(saved) : [];

    const mergedOrder = [
      ...defaultColumnOrder.filter((col) => !savedOrder.includes(col)),
      ...savedOrder,
    ];

    return mergedOrder;
  });

  // Filter options
  const filterOptions = [
    { value: "projectId", label: "Project ID" },
    { value: "status", label: "Status" },
    { value: "subStatus", label: "Sub Status" },
    { value: "customer", label: "Customer" },
    { value: "type", label: "Project Type" },
    { value: "category", label: "Category" },
    { value: "salesperson", label: "Salesperson" },
    { value: "manager", label: "Project Manager" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ].sort((a, b) => a.label.localeCompare(b.label));

  const [customerSearch, setCustomerSearch] = useState("");

  const [projectTypes, setProjectTypes] = useState([]);
  const [projectTypeMap, setProjectTypeMap] = useState({});
  const [projectsLoading, setProjectsLoading] = useState(true);

  const [selectedTeamFilter, setSelectedTeamFilter] = useState("");
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
  const [selectedCreatedByFilter, setSelectedCreatedByFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [resources, setResources] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "",
  });

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "44px",
      height: "auto",
      borderRadius: "6px",
      borderColor: "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,0.25)" : "none",
      "&:hover": {
        borderColor: "#80bdff",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 8px",
      flexWrap: "wrap",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#e7f1ff",
      borderRadius: "4px",
      margin: "2px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#0c63e4",
      fontSize: "12px",
      padding: "2px 6px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#0c63e4",
      "&:hover": {
        backgroundColor: "#0c63e4",
        color: "white",
        borderRadius: "0 4px 4px 0",
      },
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "44px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = String(userDetails?.userId);
  const orgId = String(userDetails?.organisationId);
  const [projectStatusList, setProjectStatusList] = useState([]);
  const [statusMap, setStatusMap] = useState({});

  const formatWithId = (name, id) => {
    if (!name && !id) return "";
    if (name && id) return `${name} (${id})`;
    return name || id;
  };

  const [searchProjectId, setSearchProjectId] = useState("");

  // Helper function to get display name from GUID using meta data
  // const getDisplayNameFromGuid = (guid, entityType) => {
  //   if (!guid) return "N/A";

  //   // Try exact match first, then lowercase, then uppercase
  //   const exactMatch = metaDataMap[entityType][guid];
  //   if (exactMatch) return exactMatch;

  //   const lowerMatch = metaDataMap[entityType][guid.toLowerCase()];
  //   if (lowerMatch) return lowerMatch;

  //   const upperMatch = metaDataMap[entityType][guid.toUpperCase()];
  //   if (upperMatch) return upperMatch;

  //   // If no match found, return the GUID with a prefix
  //   return `${guid.substring(0, 8)}...`;
  // };

  const getDisplayNameFromGuid = (guid, entityType) => {
    if (!guid) return "N/A";

    const key = String(guid).toLowerCase(); // ✅ FORCE STRING

    return metaDataMap[entityType][key] || "N/A";
  };

  const filteredProjects = useMemo(() => {
    return [...projects]
      .filter((project) => {
        const statusMatch =
          selectedStatusFilter.length > 0
            ? selectedStatusFilter.some(
                (s) => s.value === project.projectStatus,
              )
            : true;

        const subStatusMatch =
          selectedSubStatusFilter.length > 0
            ? selectedSubStatusFilter.some(
                (ss) => ss.value === project.projectSubStatus,
              )
            : true;

        const projectIdMatch = searchProjectId
          ? String(project.projectId)
              .toLowerCase()
              .includes(searchProjectId.toLowerCase())
          : true;

        const customerMatch =
          selectedCustomerFilter.length > 0
            ? selectedCustomerFilter.some((c) => c.value === project.prClient)
            : true;

        const typeMatch =
          selectedTypeFilter.length > 0
            ? selectedTypeFilter.some((t) => t.value === project.prTypes)
            : true;

        const teamMatch = selectedTeamFilter
          ? project.teamAssigned
              ?.toLowerCase()
              .includes(selectedTeamFilter.toLowerCase())
          : true;

        const categoryMatch = selectedCategoryFilter
          ? project.projectCategory === selectedCategoryFilter
          : true;

        const createdByMatch = selectedCreatedByFilter
          ? project.createdBy === selectedCreatedByFilter
          : true;

        const salespersonMatch =
          selectedSalespersonFilter.length > 0
            ? selectedSalespersonFilter.some(
                (s) => s.value === project.salespersonCode,
              )
            : true;

        const managerMatch =
          selectedProjectManagerFilter.length > 0
            ? selectedProjectManagerFilter.some(
                (m) => m.value === project.currentProjectManager,
              )
            : true;

        const startDateMatch = startDateFilter
          ? new Date(project.prStartDate) >= new Date(startDateFilter)
          : true;

        const endDateMatch = endDateFilter
          ? new Date(project.prEndDate) <= new Date(endDateFilter)
          : true;

        const searchMatch = searchTitle
          ? project.prTitle?.toLowerCase().includes(searchTitle.toLowerCase())
          : true;

        const startDate = startDateFilter ? new Date(startDateFilter) : null;
        const endDate = endDateFilter ? new Date(endDateFilter) : null;

        const projectStart = project.prStartDate
          ? new Date(project.prStartDate)
          : null;
        const projectEnd = project.prEndDate
          ? new Date(project.prEndDate)
          : null;

        let dateMatch = true;

        if (startDate && projectEnd) {
          dateMatch = projectEnd >= startDate;
        }

        if (endDate && projectStart) {
          dateMatch = dateMatch && projectStart <= endDate;
        }

        return (
          statusMatch &&
          subStatusMatch &&
          customerMatch &&
          typeMatch &&
          teamMatch &&
          categoryMatch &&
          createdByMatch &&
          salespersonMatch &&
          managerMatch &&
          dateMatch &&
          searchMatch &&
          projectIdMatch
        );
      })
      .sort((a, b) => {
        if (!sortConfig.key) return 0;

        const dateA = a[sortConfig.key]
          ? new Date(a[sortConfig.key]).getTime()
          : 0;
        const dateB = b[sortConfig.key]
          ? new Date(b[sortConfig.key]).getTime()
          : 0;

        return sortConfig.direction === "asc" ? dateA - dateB : dateB - dateA;
      });
  }, [
    projects,
    selectedStatusFilter,
    selectedSubStatusFilter,
    selectedCustomerFilter,
    selectedTypeFilter,
    selectedTeamFilter,
    selectedCategoryFilter,
    selectedCreatedByFilter,
    selectedSalespersonFilter,
    selectedProjectManagerFilter,
    startDateFilter,
    endDateFilter,
    searchTitle,
    sortConfig,
    searchProjectId,
  ]);

  const roles = userDetails?.roles || [];
  const isAdmin = roles.includes("Admin");

  const renderSortArrow = (key) => {
    if (sortConfig.key !== key) return "↕";
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  const [projectData, setProjectData] = useState({
    prTitle: "",
    prDescription: "",
    prTags: "",
    prStartDate: "",
    prEndDate: "",
    prClient: "",
    prTypes: "",
    teamAssigned: "",
    projectStatus: "",
    projectCategory: "",
    comments: "",
    salespersonCode: "",
    currentProjectManager: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const fetchMetaNames = async (projectsList) => {
    try {
      if (!projectsList || projectsList.length === 0) return;

      // Collect GUIDs
      const typeGuids = [
        ...new Set(projectsList.map((p) => p.prTypes).filter(Boolean)),
      ].join(",");

      const statusGuids = [
        ...new Set(projectsList.map((p) => p.projectStatus).filter(Boolean)),
      ].join(",");

      const subStatusGuids = [
        ...new Set(projectsList.map((p) => p.projectSubStatus).filter(Boolean)),
      ].join(",");

      console.log("Calling meta API with:", {
        typeGuids,
        statusGuids,
        subStatusGuids,
      });

      const response = await getProjectMetaNames(
        typeGuids,
        statusGuids,
        subStatusGuids,
      );

      const typeMap = {};
      const statusMap = {};
      const substatusMap = {};

      response.forEach((item) => {
        const key = item.guid.toLowerCase();

        if (item.entity === "TYPE") typeMap[key] = item.name;
        if (item.entity === "STATUS") statusMap[key] = item.name;
        if (item.entity === "SUBSTATUS") substatusMap[key] = item.name;
      });

      setMetaDataMap({
        type: typeMap,
        status: statusMap,
        substatus: substatusMap,
      });

      setIsMetaDataLoaded(true);
    } catch (err) {
      console.error("Meta fetch error:", err);
      setIsMetaDataLoaded(true);
    }
  };

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setProjectsLoading(true);

        let data;
        if (isAdmin) {
          data = await fetchProjectsByOrg(orgId);
        } else {
          data = await fetchProjectsByTeamMember(orgId, userId);
        }

        setProjects(data || []);

        // Call meta after projects load
        await fetchMetaNames(data);
      } catch (error) {
        toast.error("🦄 Error Fetching Projects");
      } finally {
        setProjectsLoading(false);
      }
    };

    if (orgId && userId) {
      loadProjects();
    }
  }, [orgId, userId, isAdmin]);

  useEffect(() => {
    const loadResources = async () => {
      try {
        const data = await fetchResourceByOrgId(orgId);
        setResources(data || []);

        const map = {};
        data.forEach((r) => {
          map[r.resourceId] = r.name;
        });

        setResourceMap(map);
      } catch (error) {
        toast.error("Failed to load resources");
      }
    };

    if (orgId) loadResources();
  }, [orgId]);

  useEffect(() => {
    const loadProjectStatus = async () => {
      try {
        const data = await getAllProjectStatus();
        const activeStatus = data.filter((s) => s.active);
        setProjectStatusList(activeStatus);
        const map = {};
        activeStatus.forEach((s) => {
          map[s.projectStatusId] = s.projectStatusDesc;
        });
        setStatusMap(map);
      } catch (error) {
        toast.error("Failed to load project status list");
      }
    };

    loadProjectStatus();
  }, []);

  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const data = await fetchCustomerMasterByOrgId(orgId);
        setCustomers(data || []);
        const map = {};
        data.forEach((customer) => {
          map[customer.customerCode] = customer.name;
        });
        setCustomerMap(map);
      } catch (error) {
        toast.error("Failed to load customer data");
      }
    };

    if (orgId) {
      loadCustomers();
    }
  }, [orgId]);

  useEffect(() => {
    const loadProjectTypes = async () => {
      try {
        const data = await fetchProjectTypes(orgId);
        const activeTypes = data.filter((t) => t.active);
        setProjectTypes(activeTypes);
        const map = {};
        activeTypes.forEach((t) => {
          map[t.projectTypeId] = t.projectTypeDesc;
        });
        setProjectTypeMap(map);
      } catch (error) {
        toast.error("Failed to load project types");
      }
    };

    if (orgId) {
      loadProjectTypes();
    }
  }, [orgId]);

  useEffect(() => {
    const loadTeams = async () => {
      try {
        const data = await getTeamsByOrg(orgId);
        setTeams(data || []);
        const map = {};
        data.forEach((team) => {
          map[team.teamId] = team.teamName;
        });
        setTeamMap(map);
      } catch (error) {
        toast.error("Failed to load teams");
      }
    };

    if (orgId) loadTeams();
  }, [orgId]);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const workbook = new (await import("xlsx")).utils.book_new();
      const worksheetData = [
        [
          "S.No",
          "Project ID",
          "Title",
          "Description",
          "Tags",
          "Start Date",
          "End Date",
          "Client",
          "Type",
          "Team",
          "Status",
          "Sub Status",
          "Category",
          // "Comments",
          "Created On",
          "Created By",
          "Changed On",
          "Changed By",
          "Salesperson",
          "Project Manager",
        ],
        ...filteredProjects.map((project, index) => [
          index + 1, // S.No
          project.projectId || "",
          project.prTitle || "",
          project.prDescription || "",
          project.prTags || "",
          project.prStartDate
            ? moment(project.prStartDate).format("YYYY-MM-DD")
            : "",
          project.prEndDate
            ? moment(project.prEndDate).format("YYYY-MM-DD")
            : "",
          // Client/Customer
          formatWithId(customerMap[project.prClient], project.prClient),
          // Project Type
          getDisplayNameFromGuid(project.prTypes, "type"),
          // Team
          formatWithId(teamMap[project.teamAssigned], project.teamAssigned),
          // Status
          getDisplayNameFromGuid(project.projectStatus, "status"),
          // Sub Status
          getDisplayNameFromGuid(project.projectSubStatus, "substatus"),
          // Category
          project.projectCategory || "",
          // Comments
          // project.comments || "",
          // Created On (Date + Time)
          project.createdOnDate
            ? `${moment(project.createdOnDate).format("YYYY-MM-DD")}${project.createdOnTime ? ` at ${project.createdOnTime.split(".")[0]}` : ""}`
            : "N/A",
          // Created By
          formatWithId(resourceMap[project.createdBy], project.createdBy),
          // Changed On (Date + Time)
          project.changedOnDate
            ? `${moment(project.changedOnDate).format("YYYY-MM-DD")}${project.changedOnTime ? ` at ${project.changedOnTime.split(".")[0]}` : ""}`
            : "N/A",
          // Changed By
          project.changedBy || "N/A",
          // Salesperson
          formatWithId(
            resourceMap[project.salespersonCode],
            project.salespersonCode,
          ),
          // Project Manager
          formatWithId(
            resourceMap[project.currentProjectManager],
            project.currentProjectManager,
          ),
        ]),
      ];

      const worksheet = (await import("xlsx")).utils.aoa_to_sheet(
        worksheetData,
      );

      // Auto-size columns (optional but helpful)
      const maxWidths = worksheetData[0].map((_, colIndex) => {
        let maxLength = worksheetData[0][colIndex]?.length || 0;
        for (let i = 1; i < worksheetData.length; i++) {
          const cellValue = worksheetData[i][colIndex]?.toString() || "";
          maxLength = Math.max(maxLength, cellValue.length);
        }
        return { wch: Math.min(maxLength + 2, 50) }; // Cap at 50 characters
      });
      worksheet["!cols"] = maxWidths;

      (await import("xlsx")).utils.book_append_sheet(
        workbook,
        worksheet,
        "Projects",
      );
      (await import("xlsx")).writeFile(
        workbook,
        `Projects_${orgId}_${moment().format("YYYYMMDD_HHmmss")}.xlsx`,
      );
      toast.success("Projects data downloaded successfully!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedProjectId("");
    setProjectData({
      prTitle: "",
      prDescription: "",
      prTags: "",
      prStartDate: "",
      prEndDate: "",
      prClient: "",
      prTypes: "",
      teamAssigned: "",
      projectStatus: "",
      projectCategory: "",
      comments: "",
      salespersonCode: "",
      currentProjectManager: "",
    });
  };

  const handleProjectSelect = async (projectId) => {
    setSelectedProjectId(projectId);
    try {
      setIsLoading(true);
      const data = await fetchProjectDetails(projectId);
      setProjectData({
        prTitle: data.prTitle || "",
        prDescription: data.prDescription || "",
        prTags: data.prTags || "",
        prStartDate: data.prStartDate
          ? moment(data.prStartDate).format("YYYY-MM-DD")
          : "",
        prEndDate: data.prEndDate
          ? moment(data.prEndDate).format("YYYY-MM-DD")
          : "",
        prClient: data.prClient || "",
        prTypes: data.prTypes || "",
        teamAssigned: data.teamAssigned || "",
        projectStatus: data.projectStatus || "",
        projectCategory: data.projectCategory || "",
        comments: data.comments || "",
        salespersonCode: data.salespersonCode || "",
        currentProjectManager: data.currentProjectManager || "",
      });
    } catch (error) {
      toast.error(`🦄 Error fetching project details`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProjectData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProjectId) {
      toast.error("Please select a project");
      return;
    }

    try {
      setIsLoading(true);
      await updateProject(selectedProjectId, projectData);
      toast.success("Project updated successfully!");

      const data = isAdmin
        ? await fetchProjectsByOrg(orgId)
        : await fetchProjectsByTeamMember(orgId, userId);

      setProjects(data || []);
      handleCloseEditModal();
    } catch (error) {
      toast.error(`🦄 Error updating project: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Build status options from meta data
  const statusOptions = useMemo(() => {
    const uniqueStatuses = new Map();
    Object.entries(metaDataMap.status).forEach(([guid, name]) => {
      if (!uniqueStatuses.has(name) && name !== guid) {
        uniqueStatuses.set(name, guid);
      }
    });

    return Array.from(uniqueStatuses.entries())
      .map(([name, guid]) => ({
        value: guid,
        label: name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [metaDataMap.status]);

  // Build sub status options from meta data
  const subStatusOptions = useMemo(() => {
    const uniqueSubStatuses = new Map();
    Object.entries(metaDataMap.substatus).forEach(([guid, name]) => {
      if (!uniqueSubStatuses.has(name) && name !== guid) {
        uniqueSubStatuses.set(name, guid);
      }
    });

    return Array.from(uniqueSubStatuses.entries())
      .map(([name, guid]) => ({
        value: guid,
        label: name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [metaDataMap.substatus]);

  // Build type options from meta data
  const typeOptions = useMemo(() => {
    const uniqueTypes = new Map();
    Object.entries(metaDataMap.type).forEach(([guid, name]) => {
      if (!uniqueTypes.has(name) && name !== guid) {
        uniqueTypes.set(name, guid);
      }
    });

    return Array.from(uniqueTypes.entries())
      .map(([name, guid]) => ({
        value: guid,
        label: name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [metaDataMap.type]);

  const customerOptions = useMemo(() => {
    return customers
      .map((c) => ({
        value: c.customerCode,
        label: c.name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [customers]);

  const resourceOptions = useMemo(() => {
    return resources
      .map((r) => ({
        value: r.resourceId,
        label: r.name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [resources]);

  useEffect(() => {
    localStorage.setItem(
      "projectVisibleFilters",
      JSON.stringify(visibleFilters),
    );
  }, [visibleFilters]);

  useEffect(() => {
    localStorage.setItem("projectColumnOrder", JSON.stringify(columnOrder));
  }, [columnOrder]);

  // Reorder columns function
  const reorderColumns = (fromIndex, toIndex) => {
    const newOrder = [...columnOrder];
    const [movedItem] = newOrder.splice(fromIndex, 1);
    newOrder.splice(toIndex, 0, movedItem);
    setColumnOrder(newOrder);
  };

  // Draggable Header Component
  const DraggableHeader = ({ column, index, children }) => {
    const [{ isDragging }, drag] = useDrag({
      type: "COLUMN",
      item: { index, column },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    const [, drop] = useDrop({
      accept: "COLUMN",
      hover: (item) => {
        if (item.index !== index) {
          reorderColumns(item.index, index);
          item.index = index;
        }
      },
    });

    return (
      <th
        ref={(node) => drag(drop(node))}
        style={{
          cursor: "move",
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: isDragging ? "#f0f0f0" : "inherit",
          userSelect: "none",
        }}
      >
        {children}
      </th>
    );
  };

  // Define column configurations
  const columnConfig = {
    index: {
      label: "#",
      render: (project, index) => <td key="index">{index + 1}</td>,
      sortable: false,
    },
    projectId: {
      label: "Project ID",
      render: (project, index) => (
        <td
          key="projectId"
          style={{ cursor: "pointer", color: "#007bff" }}
          onClick={() => navigate(`/project/${project.projectId}`)}
        >
          {project.projectId}
        </td>
      ),
      sortable: false,
    },
    title: {
      label: "Title",
      render: (project) => <td key="title">{project.prTitle}</td>,
      sortable: false,
    },
    description: {
      label: "Description",
      render: (project) => <td key="description">{project.prDescription}</td>,
      sortable: false,
    },
    tags: {
      label: "Tags",
      render: (project) => <td key="tags">{project.prTags}</td>,
      sortable: false,
    },
    startDate: {
      label: "Start Date",
      render: (project) => (
        <td key="startDate">
          {project.prStartDate
            ? moment(project.prStartDate).format("L")
            : "N/A"}
        </td>
      ),
      sortable: true,
      sortKey: "prStartDate",
    },
    endDate: {
      label: "End Date",
      render: (project) => (
        <td key="endDate">
          {project.prEndDate ? moment(project.prEndDate).format("L") : "N/A"}
        </td>
      ),
      sortable: true,
      sortKey: "prEndDate",
    },
    client: {
      label: "Client",
      render: (project) => (
        <td key="client">
          {formatWithId(customerMap[project.prClient], project.prClient) ||
            "N/A"}
        </td>
      ),
      sortable: false,
    },
    type: {
      label: "Type",
      render: (project) => {
        const displayName = getDisplayNameFromGuid(project.prTypes, "type");
        return <td key="type">{displayName}</td>;
      },
      sortable: false,
    },
    team: {
      label: "Team",
      render: (project) => (
        <td key="team">
          {formatWithId(teamMap[project.teamAssigned], project.teamAssigned)}
        </td>
      ),
      sortable: false,
    },
    status: {
      label: "Status",
      render: (project) => {
        const displayName = getDisplayNameFromGuid(
          project.projectStatus,
          "status",
        );
        return <td key="status">{displayName}</td>;
      },
      sortable: false,
    },
    subStatus: {
      label: "Sub Status",
      render: (project) => {
        const displayName = getDisplayNameFromGuid(
          project.projectSubStatus,
          "substatus",
        );
        return <td key="subStatus">{displayName}</td>;
      },
      sortable: false,
    },
    category: {
      label: "Category",
      render: (project) => <td key="category">{project.projectCategory}</td>,
      sortable: false,
    },
    comments: {
      label: "Comments",
      render: (project) => <td key="comments">{project.comments}</td>,
      sortable: false,
    },
    createdOn: {
      label: "Created On",
      render: (project) => (
        <td key="createdOn">
          {project.createdOnDate
            ? moment(project.createdOnDate).format("L")
            : "N/A"}
          {project.createdOnTime &&
            ` at ${project.createdOnTime.split(".")[0]}`}
        </td>
      ),
      sortable: true,
      sortKey: "createdOnDate",
    },
    createdBy: {
      label: "Created By",
      render: (project) => (
        <td key="createdBy">{project.createdBy || "N/A"}</td>
      ),
      sortable: false,
    },
    changedOn: {
      label: "Changed On",
      render: (project) => (
        <td key="changedOn">
          {project.changedOnDate
            ? moment(project.changedOnDate).format("L")
            : "N/A"}
          {project.changedOnTime &&
            ` at ${project.changedOnTime.split(".")[0]}`}
        </td>
      ),
      sortable: true,
      sortKey: "changedOnDate",
    },
    changedBy: {
      label: "Changed By",
      render: (project) => <td key="changedBy">{project.changedBy}</td>,
      sortable: false,
    },
    salesperson: {
      label: "Salesperson Code",
      render: (project) => (
        <td key="salesperson">
          {formatWithId(
            resourceMap[project.salespersonCode],
            project.salespersonCode,
          )}
        </td>
      ),
      sortable: false,
    },
    projectManager: {
      label: "Project Manager",
      render: (project) => (
        <td key="projectManager">
          {formatWithId(
            resourceMap[project.currentProjectManager],
            project.currentProjectManager,
          )}
        </td>
      ),
      sortable: false,
    },
  };

  // Active Filters Display Component
  const ActiveFilters = () => {
    const allActiveFilters = [
      ...selectedStatusFilter.map((f) => ({
        type: "Status",
        label: f.label,
        onRemove: () =>
          setSelectedStatusFilter(
            selectedStatusFilter.filter((s) => s.value !== f.value),
          ),
      })),
      ...selectedSubStatusFilter.map((f) => ({
        type: "Sub Status",
        label: f.label,
        onRemove: () =>
          setSelectedSubStatusFilter(
            selectedSubStatusFilter.filter((ss) => ss.value !== f.value),
          ),
      })),
      ...selectedCustomerFilter.map((f) => ({
        type: "Customer",
        label: f.label,
        onRemove: () =>
          setSelectedCustomerFilter(
            selectedCustomerFilter.filter((c) => c.value !== f.value),
          ),
      })),
      ...selectedTypeFilter.map((f) => ({
        type: "Project Type",
        label: f.label,
        onRemove: () =>
          setSelectedTypeFilter(
            selectedTypeFilter.filter((t) => t.value !== f.value),
          ),
      })),
      ...selectedSalespersonFilter.map((f) => ({
        type: "Salesperson",
        label: f.label,
        onRemove: () =>
          setSelectedSalespersonFilter(
            selectedSalespersonFilter.filter((s) => s.value !== f.value),
          ),
      })),
      ...selectedProjectManagerFilter.map((f) => ({
        type: "Project Manager",
        label: f.label,
        onRemove: () =>
          setSelectedProjectManagerFilter(
            selectedProjectManagerFilter.filter((m) => m.value !== f.value),
          ),
      })),
    ];

    if (
      allActiveFilters.length === 0 &&
      !selectedCategoryFilter &&
      !startDateFilter &&
      !endDateFilter &&
      !searchTitle &&
      !searchProjectId
    ) {
      return null;
    }

    return (
      <div className="vp-active-filters">
        <div className="vp-active-filters-label">Active Filters:</div>
        <div className="vp-active-filters-list">
          {searchTitle && (
            <Badge bg="info" className="vp-filter-badge">
              Search: "{searchTitle}"
              <FaTimes
                className="vp-filter-badge-remove"
                onClick={() => setSearchTitle("")}
              />
            </Badge>
          )}
          {searchProjectId && (
            <Badge bg="info" className="vp-filter-badge">
              Project ID: {searchProjectId}
              <FaTimes
                className="vp-filter-badge-remove"
                onClick={() => setSearchProjectId("")}
              />
            </Badge>
          )}
          {selectedCategoryFilter && (
            <Badge bg="info" className="vp-filter-badge">
              Category: {selectedCategoryFilter}
              <FaTimes
                className="vp-filter-badge-remove"
                onClick={() => setSelectedCategoryFilter("")}
              />
            </Badge>
          )}
          {startDateFilter && (
            <Badge bg="info" className="vp-filter-badge">
              Start Date ≥ {moment(startDateFilter).format("L")}
              <FaTimes
                className="vp-filter-badge-remove"
                onClick={() => setStartDateFilter("")}
              />
            </Badge>
          )}
          {endDateFilter && (
            <Badge bg="info" className="vp-filter-badge">
              End Date ≤ {moment(endDateFilter).format("L")}
              <FaTimes
                className="vp-filter-badge-remove"
                onClick={() => setEndDateFilter("")}
              />
            </Badge>
          )}
          {allActiveFilters.map((filter, idx) => (
            <Badge key={idx} bg="primary" className="vp-filter-badge">
              {filter.type}: {filter.label}
              <FaTimes
                className="vp-filter-badge-remove"
                onClick={filter.onRemove}
              />
            </Badge>
          ))}
        </div>
        {(allActiveFilters.length > 0 ||
          selectedCategoryFilter ||
          startDateFilter ||
          endDateFilter ||
          searchTitle) && (
          <Button
            variant="link"
            className="vp-clear-all-filters"
            onClick={() => {
              setSearchTitle("");
              setSearchProjectId("");
              setSelectedStatusFilter([]);
              setSelectedSubStatusFilter([]);
              setSelectedCustomerFilter([]);
              setSelectedTypeFilter([]);
              setSelectedSalespersonFilter([]);
              setSelectedProjectManagerFilter([]);
              setSelectedTeamFilter("");
              setSelectedCategoryFilter("");
              setSelectedCreatedByFilter("");
              setStartDateFilter("");
              setEndDateFilter("");
            }}
          >
            Clear All
          </Button>
        )}
      </div>
    );
  };

  // Show loading while meta data is being fetched
  if (!isMetaDataLoaded) {
    return (
      <div className="vp-d-flex vp-justify-content-center vp-align-items-center vp-py-5">
        <Spinner animation="border" variant="primary" />
        <span className="ms-3">Loading project data...</span>
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="vp-main-content expand">
        <Container fluid className="vp-list-container">
          <div
            className="vp-d-flex vp-justify-content-between vp-align-items-center vp-mb-3"
            style={{ flexDirection: "column" }}
          >
            <div>
              {" "}
              <h2 className="vp-list-title" style={{ fontSize: "2.0rem" }}>
                View Projects
              </h2>{" "}
            </div>
            <div className="vp-filter-panel">
              {/* FIRST ROW */}
              <Row className="g-3 align-items-end">
                <div style={{ display: "flex", gap: "16px" }}>
                  <Col className="d-flex  gap-2">
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">Display Filters</div>
                      <Select
                        isMulti
                        options={filterOptions}
                        value={filterOptions.filter((f) =>
                          visibleFilters.includes(f.value),
                        )}
                        onChange={(selected) =>
                          setVisibleFilters(selected.map((s) => s.value))
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={customSelectStyles}
                      />
                    </div>
                  </Col>
                  <Button
                    className="vp-generate-btn"
                    variant="primary"
                    onClick={handleDownload}
                    style={{ marginTop: "16px" }}
                  >
                    <FaDownload />
                  </Button>
                </div>

                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Col md={3} className="gap-2">
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">Search Project</div>
                      <Form.Control
                        type="text"
                        placeholder="Search by title..."
                        value={searchTitle}
                        onChange={(e) => setSearchTitle(e.target.value)}
                      />
                    </div>
                  </Col>

                  {visibleFilters.includes("projectId") && (
                    <Col md={2}>
                      <div className="vp-filter-box">
                        <div className="vp-filter-label">Project ID</div>
                        <Form.Control
                          type="text"
                          placeholder="Search by Project ID..."
                          value={searchProjectId}
                          onChange={(e) => setSearchProjectId(e.target.value)}
                        />
                      </div>
                    </Col>
                  )}

                  {visibleFilters.includes("status") && (
                    <Col md={2}>
                      <div className="vp-filter-box">
                        <div className="vp-filter-label">Status</div>
                        <Select
                          isMulti
                          options={statusOptions}
                          value={selectedStatusFilter}
                          onChange={setSelectedStatusFilter}
                          styles={customSelectStyles}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select status..."
                        />
                      </div>
                    </Col>
                  )}

                  {visibleFilters.includes("subStatus") && (
                    <Col md={2}>
                      <div className="vp-filter-box">
                        <div className="vp-filter-label">Sub Status</div>
                        <Select
                          isMulti
                          options={subStatusOptions}
                          value={selectedSubStatusFilter}
                          onChange={setSelectedSubStatusFilter}
                          styles={customSelectStyles}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select sub status..."
                        />
                      </div>
                    </Col>
                  )}

                  {visibleFilters.includes("customer") && (
                    <Col md={2}>
                      <div className="vp-filter-box">
                        <div className="vp-filter-label">Customer</div>
                        <Select
                          isMulti
                          options={customerOptions}
                          value={selectedCustomerFilter}
                          onChange={setSelectedCustomerFilter}
                          styles={customSelectStyles}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select customers..."
                        />
                      </div>
                    </Col>
                  )}

                  {visibleFilters.includes("type") && (
                    <Col md={2}>
                      <div className="vp-filter-box">
                        <div className="vp-filter-label">Project Type</div>
                        <Select
                          isMulti
                          options={typeOptions}
                          value={selectedTypeFilter}
                          onChange={setSelectedTypeFilter}
                          styles={customSelectStyles}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          placeholder="Select types..."
                        />
                      </div>
                    </Col>
                  )}

                  <Col
                    md={2}
                    className="d-flex align-items-end gap-2"
                    style={{ width: "120px" }}
                  >
                    <Button
                      variant="outline-secondary"
                      onClick={() => {
                        setSearchTitle("");
                        setSearchProjectId("");
                        setSelectedStatusFilter([]);
                        setSelectedSubStatusFilter([]);
                        setSelectedCustomerFilter([]);
                        setSelectedTypeFilter([]);
                        setSelectedSalespersonFilter([]);
                        setSelectedProjectManagerFilter([]);
                        setSelectedTeamFilter("");
                        setSelectedCategoryFilter("");
                        setSelectedCreatedByFilter("");
                        setStartDateFilter("");
                        setEndDateFilter("");
                      }}
                    >
                      Reset
                    </Button>
                  </Col>
                </div>
              </Row>

              {/* SECOND ROW */}
              <Row className="g-3 mt-1 align-items-end">
                {visibleFilters.includes("category") && (
                  <Col md={2}>
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">Category</div>
                      <Form.Select
                        value={selectedCategoryFilter}
                        onChange={(e) =>
                          setSelectedCategoryFilter(e.target.value)
                        }
                      >
                        <option value="">All</option>
                        <option value="Internal">Internal</option>
                        <option value="External">External</option>
                      </Form.Select>
                    </div>
                  </Col>
                )}

                {visibleFilters.includes("salesperson") && (
                  <Col md={2}>
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">Salesperson</div>
                      <Select
                        isMulti
                        options={resourceOptions}
                        value={selectedSalespersonFilter}
                        onChange={setSelectedSalespersonFilter}
                        styles={customSelectStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Select salespersons..."
                      />
                    </div>
                  </Col>
                )}

                {visibleFilters.includes("manager") && (
                  <Col md={2}>
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">Project Manager</div>
                      <Select
                        isMulti
                        options={resourceOptions}
                        value={selectedProjectManagerFilter}
                        onChange={setSelectedProjectManagerFilter}
                        styles={customSelectStyles}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Select managers..."
                      />
                    </div>
                  </Col>
                )}

                {visibleFilters.includes("startDate") && (
                  <Col md={2}>
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">Start Date</div>
                      <Form.Control
                        type="date"
                        value={startDateFilter}
                        onChange={(e) => setStartDateFilter(e.target.value)}
                      />
                    </div>
                  </Col>
                )}

                {visibleFilters.includes("endDate") && (
                  <Col md={2}>
                    <div className="vp-filter-box">
                      <div className="vp-filter-label">End Date</div>
                      <Form.Control
                        type="date"
                        value={endDateFilter}
                        onChange={(e) => setEndDateFilter(e.target.value)}
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>

          {/* Active Filters Display */}
          <ActiveFilters />

          {projectsLoading ? (
            <div className="vp-d-flex vp-justify-content-center vp-align-items-center vp-py-5">
              <Spinner animation="border" variant="primary" />
              <span className="ms-3">Loading projects...</span>
            </div>
          ) : projects.length > 0 ? (
            <div className="vp-table-wrapper">
              <div className="vp-table-scroll-container">
                <Table bordered hover className="vp-data-table">
                  <thead>
                    <tr>
                      {columnOrder.map((columnKey, index) => {
                        const column = columnConfig[columnKey];
                        if (!column) return null;
                        return (
                          <DraggableHeader
                            key={columnKey}
                            column={columnKey}
                            index={index}
                          >
                            {column.sortable ? (
                              <div
                                style={{
                                  cursor: "pointer",
                                  userSelect: "none",
                                }}
                                onClick={() => handleSort(column.sortKey)}
                              >
                                {column.label} {renderSortArrow(column.sortKey)}
                              </div>
                            ) : (
                              column.label
                            )}
                          </DraggableHeader>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredProjects.map((project, index) => {
                      console.log("SubStatus GUID:", project.projectSubStatus); // 👈 ADD HERE

                      return (
                        <tr key={index}>
                          {columnOrder.map((columnKey) => {
                            const column = columnConfig[columnKey];
                            if (!column) return null;
                            return column.render(project, index);
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="vp-no-data">No projects found.</p>
          )}
        </Container>
      </div>

      {/* Edit Project Modal */}
      <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formProjectId">
                <Form.Label>Project ID</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedProjectId}
                  onChange={(e) => handleProjectSelect(e.target.value)}
                  required
                >
                  <option value="">Select a project</option>
                  {projects.map((project) => (
                    <option key={project.projectId} value={project.projectId}>
                      {project.projectId} - {project.prTitle}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formTitle">
                <Form.Label>Project Title</Form.Label>
                <Form.Control
                  type="text"
                  name="prTitle"
                  value={projectData.prTitle}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formDescription">
                <Form.Label>Project Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="prDescription"
                  value={projectData.prDescription}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formTags">
                <Form.Label>Project Tags</Form.Label>
                <Form.Control
                  type="text"
                  name="prTags"
                  value={projectData.prTags}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formClient">
                <Form.Label>Project Client</Form.Label>
                <Form.Control
                  type="text"
                  name="prClient"
                  value={projectData.prClient}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="prStartDate"
                  value={projectData.prStartDate}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formEndDate">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="prEndDate"
                  value={projectData.prEndDate}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formType">
                <Form.Label>Project Type</Form.Label>
                <Form.Control
                  as="select"
                  name="prTypes"
                  value={projectData.prTypes}
                  onChange={handleInputChange}
                >
                  <option value="">Select Project Type</option>
                  {projectTypes.map((type) => (
                    <option key={type.projectTypeId} value={type.projectTypeId}>
                      {type.projectTypeDesc}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group as={Col} controlId="formTeam">
                <Form.Label>Team Assigned</Form.Label>
                <Form.Control
                  type="text"
                  name="teamAssigned"
                  value={projectData.teamAssigned}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formStatus">
                <Form.Label>Project Status</Form.Label>
                <Form.Control
                  as="select"
                  name="projectStatus"
                  value={projectData.projectStatus}
                  onChange={handleInputChange}
                >
                  <option value="">Select Status</option>
                  {projectStatusList.map((status) => (
                    <option
                      key={status.projectStatusId}
                      value={status.projectStatusId}
                    >
                      {status.projectStatusDesc}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group as={Col} controlId="formCategory">
                <Form.Label>Project Category</Form.Label>
                <Form.Control
                  as="select"
                  name="projectCategory"
                  value={projectData.projectCategory}
                  onChange={handleInputChange}
                >
                  <option value="">Select Category</option>
                  <option value="Internal">Internal</option>
                  <option value="External">External</option>
                </Form.Control>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formComments">
                <Form.Label>Comments</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="comments"
                  value={projectData.comments}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formSalesperson">
                <Form.Label>Salesperson Code</Form.Label>
                <Form.Control
                  type="text"
                  name="salespersonCode"
                  value={projectData.salespersonCode}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formManager">
                <Form.Label>Project Manager</Form.Label>
                <Form.Control
                  type="text"
                  name="currentProjectManager"
                  value={projectData.currentProjectManager}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Row>

            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                onClick={handleCloseEditModal}
                className="me-2"
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={isLoading}>
                {isLoading ? "Updating..." : "Update Project"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </DndProvider>
  );
};

export default ViewProjects;

// import { useEffect, useState } from "react";
// import {
//   fetchProjects,
//   downloadProjectsExcel,
//   fetchProjectDetails,
//   updateProject,
//   fetchProjectsByOrg,
//   fetchProjectsByTeamMember,
// } from "../Api/ViewProjects";
// import { getTeamsByOrg } from "../Api/TeamMaster";
// import {
//   Container,
//   Table,
//   Button,
//   Modal,
//   Form,
//   Row,
//   Col,
//   Badge,
// } from "react-bootstrap";
// import { toast } from "react-toastify";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import { getAllProjectStatus } from "../Api/ProjectStatusApi";
// import { fetchCustomerMasterByOrgId } from "../Api/ViewCustomerMaster";
// import { FaDownload, FaTimes } from "react-icons/fa";
// import { fetchProjectTypes } from "../Api/InvoiceApi";
// import { Spinner } from "react-bootstrap";
// import { useMemo } from "react";
// import Select from "react-select";
// import "./ViewProject.css";
// import { fetchResourceByOrgId } from "../Api/InvoiceApi";
// import { DndProvider, useDrag, useDrop } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";

// const ViewProjects = () => {
//   const [projects, setProjects] = useState([]);
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedProjectId, setSelectedProjectId] = useState("");
//   const navigate = useNavigate();

//   const [selectedStatusFilter, setSelectedStatusFilter] = useState([]);
//   const [selectedCustomerFilter, setSelectedCustomerFilter] = useState([]);
//   const [selectedTypeFilter, setSelectedTypeFilter] = useState([]);
//   const [selectedSalespersonFilter, setSelectedSalespersonFilter] = useState(
//     [],
//   );
//   const [selectedProjectManagerFilter, setSelectedProjectManagerFilter] =
//     useState([]);

//   const [resourceMap, setResourceMap] = useState({});

//   const [searchTitle, setSearchTitle] = useState("");
//   const [customerMap, setCustomerMap] = useState({});
//   const [customers, setCustomers] = useState([]);

//   const [teams, setTeams] = useState([]);
//   const [teamMap, setTeamMap] = useState({});

//   const defaultFilters = [
//     "projectId",
//     "status",
//     "customer",
//     "type",
//     "salesperson",
//     "manager",
//     "category",
//     "startDate",
//     "endDate",
//   ];

//   const [visibleFilters, setVisibleFilters] = useState(() => {
//     const saved = localStorage.getItem("projectVisibleFilters");
//     return saved ? JSON.parse(saved) : defaultFilters;
//   });

//   // Define initial column order
//   const defaultColumnOrder = [
//     "index",
//     "projectId",
//     "title",
//     "description",
//     "tags",
//     "startDate",
//     "endDate",
//     "client",
//     "type",
//     "team",
//     "status",
//     "category",
//     "comments",
//     "createdOn",
//     "createdBy",
//     "changedOn",
//     "changedBy",
//     "salesperson",
//     "projectManager",
//   ];

//   const [columnOrder, setColumnOrder] = useState(() => {
//     const saved = localStorage.getItem("projectColumnOrder");
//     return saved ? JSON.parse(saved) : defaultColumnOrder;
//   });

//   // Filter options
//   const filterOptions = [
//     { value: "projectId", label: "Project ID" },
//     { value: "status", label: "Status" },
//     { value: "customer", label: "Customer" },
//     { value: "type", label: "Project Type" },
//     { value: "category", label: "Category" },
//     { value: "salesperson", label: "Salesperson" },
//     { value: "manager", label: "Project Manager" },
//     { value: "startDate", label: "Start Date" },
//     { value: "endDate", label: "End Date" },
//   ].sort((a, b) => a.label.localeCompare(b.label));

//   const [customerSearch, setCustomerSearch] = useState("");

//   const [projectTypes, setProjectTypes] = useState([]);
//   const [projectTypeMap, setProjectTypeMap] = useState({});
//   const [projectsLoading, setProjectsLoading] = useState(true);

//   const [selectedTeamFilter, setSelectedTeamFilter] = useState("");
//   const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
//   const [selectedCreatedByFilter, setSelectedCreatedByFilter] = useState("");
//   const [startDateFilter, setStartDateFilter] = useState("");
//   const [endDateFilter, setEndDateFilter] = useState("");
//   const [resources, setResources] = useState([]);
//   const [sortConfig, setSortConfig] = useState({
//     key: "",
//     direction: "",
//   });

//   const customSelectStyles = {
//     control: (base, state) => ({
//       ...base,
//       minHeight: "44px",
//       height: "auto",
//       borderRadius: "6px",
//       borderColor: "#ced4da",
//       boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,0.25)" : "none",
//       "&:hover": {
//         borderColor: "#80bdff",
//       },
//     }),
//     valueContainer: (base) => ({
//       ...base,
//       padding: "2px 8px",
//       flexWrap: "wrap",
//     }),
//     multiValue: (base) => ({
//       ...base,
//       backgroundColor: "#e7f1ff",
//       borderRadius: "4px",
//       margin: "2px",
//     }),
//     multiValueLabel: (base) => ({
//       ...base,
//       color: "#0c63e4",
//       fontSize: "12px",
//       padding: "2px 6px",
//     }),
//     multiValueRemove: (base) => ({
//       ...base,
//       color: "#0c63e4",
//       "&:hover": {
//         backgroundColor: "#0c63e4",
//         color: "white",
//         borderRadius: "0 4px 4px 0",
//       },
//     }),
//     indicatorsContainer: (base) => ({
//       ...base,
//       height: "44px",
//     }),
//     menuPortal: (base) => ({
//       ...base,
//       zIndex: 9999,
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 9999,
//     }),
//   };

//   const handleSort = (key) => {
//     setSortConfig((prev) => {
//       if (prev.key === key) {
//         return {
//           key,
//           direction: prev.direction === "asc" ? "desc" : "asc",
//         };
//       }
//       return { key, direction: "asc" };
//     });
//   };

//   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//   const userId = String(userDetails?.userId);
//   const orgId = String(userDetails?.organisationId);
//   const [projectStatusList, setProjectStatusList] = useState([]);
//   const [statusMap, setStatusMap] = useState({});

//   const formatWithId = (name, id) => {
//     if (!name && !id) return "";
//     if (name && id) return `${name} (${id})`;
//     return name || id;
//   };

//   const [searchProjectId, setSearchProjectId] = useState("");

//   const filteredProjects = useMemo(() => {
//     return [...projects]
//       .filter((project) => {
//         const statusMatch =
//           selectedStatusFilter.length > 0
//             ? selectedStatusFilter.some(
//                 (s) => s.value === project.projectStatus,
//               )
//             : true;

//         const projectIdMatch = searchProjectId
//           ? String(project.projectId)
//               .toLowerCase()
//               .includes(searchProjectId.toLowerCase())
//           : true;

//         const customerMatch =
//           selectedCustomerFilter.length > 0
//             ? selectedCustomerFilter.some((c) => c.value === project.prClient)
//             : true;

//         const typeMatch =
//           selectedTypeFilter.length > 0
//             ? selectedTypeFilter.some((t) => t.value === project.prTypes)
//             : true;

//         const teamMatch = selectedTeamFilter
//           ? project.teamAssigned
//               ?.toLowerCase()
//               .includes(selectedTeamFilter.toLowerCase())
//           : true;

//         const categoryMatch = selectedCategoryFilter
//           ? project.projectCategory === selectedCategoryFilter
//           : true;

//         const createdByMatch = selectedCreatedByFilter
//           ? project.createdBy === selectedCreatedByFilter
//           : true;

//         const salespersonMatch =
//           selectedSalespersonFilter.length > 0
//             ? selectedSalespersonFilter.some(
//                 (s) => s.value === project.salespersonCode,
//               )
//             : true;

//         const managerMatch =
//           selectedProjectManagerFilter.length > 0
//             ? selectedProjectManagerFilter.some(
//                 (m) => m.value === project.currentProjectManager,
//               )
//             : true;

//         const startDateMatch = startDateFilter
//           ? new Date(project.prStartDate) >= new Date(startDateFilter)
//           : true;

//         const endDateMatch = endDateFilter
//           ? new Date(project.prEndDate) <= new Date(endDateFilter)
//           : true;

//         const searchMatch = searchTitle
//           ? project.prTitle?.toLowerCase().includes(searchTitle.toLowerCase())
//           : true;

//         const startDate = startDateFilter ? new Date(startDateFilter) : null;
//         const endDate = endDateFilter ? new Date(endDateFilter) : null;

//         const projectStart = project.prStartDate
//           ? new Date(project.prStartDate)
//           : null;
//         const projectEnd = project.prEndDate
//           ? new Date(project.prEndDate)
//           : null;

//         let dateMatch = true;

//         if (startDate && projectEnd) {
//           dateMatch = projectEnd >= startDate;
//         }

//         if (endDate && projectStart) {
//           dateMatch = dateMatch && projectStart <= endDate;
//         }

//         return (
//           statusMatch &&
//           customerMatch &&
//           typeMatch &&
//           teamMatch &&
//           categoryMatch &&
//           createdByMatch &&
//           salespersonMatch &&
//           managerMatch &&
//           dateMatch &&
//           searchMatch &&
//           projectIdMatch
//         );
//       })
//       .sort((a, b) => {
//         if (!sortConfig.key) return 0;

//         const dateA = a[sortConfig.key]
//           ? new Date(a[sortConfig.key]).getTime()
//           : 0;
//         const dateB = b[sortConfig.key]
//           ? new Date(b[sortConfig.key]).getTime()
//           : 0;

//         return sortConfig.direction === "asc" ? dateA - dateB : dateB - dateA;
//       });
//   }, [
//     projects,
//     selectedStatusFilter,
//     selectedCustomerFilter,
//     selectedTypeFilter,
//     selectedTeamFilter,
//     selectedCategoryFilter,
//     selectedCreatedByFilter,
//     selectedSalespersonFilter,
//     selectedProjectManagerFilter,
//     startDateFilter,
//     endDateFilter,
//     searchTitle,
//     sortConfig,
//     searchProjectId,
//   ]);

//   const roles = userDetails?.roles || [];
//   const isAdmin = roles.includes("Admin");

//   const renderSortArrow = (key) => {
//     if (sortConfig.key !== key) return "↕";
//     return sortConfig.direction === "asc" ? "↑" : "↓";
//   };

//   const [projectData, setProjectData] = useState({
//     prTitle: "",
//     prDescription: "",
//     prTags: "",
//     prStartDate: "",
//     prEndDate: "",
//     prClient: "",
//     prTypes: "",
//     teamAssigned: "",
//     projectStatus: "",
//     projectCategory: "",
//     comments: "",
//     salespersonCode: "",
//     currentProjectManager: "",
//   });
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const loadProjects = async () => {
//       try {
//         setProjectsLoading(true);

//         let data;
//         if (isAdmin) {
//           data = await fetchProjectsByOrg(orgId);
//         } else {
//           data = await fetchProjectsByTeamMember(orgId, userId);
//         }

//         setProjects(Array.isArray(data) ? data : []);
//       } catch (error) {
//         toast.error("🦄 Error Fetching Projects");
//       } finally {
//         setProjectsLoading(false);
//       }
//     };

//     if (orgId && userId) {
//       loadProjects();
//     }
//   }, [orgId, userId, isAdmin]);

//   useEffect(() => {
//     const loadResources = async () => {
//       try {
//         const data = await fetchResourceByOrgId(orgId);
//         setResources(data || []);

//         const map = {};
//         data.forEach((r) => {
//           map[r.resourceId] = r.name;
//         });

//         setResourceMap(map);
//       } catch (error) {
//         toast.error("Failed to load resources");
//       }
//     };

//     if (orgId) loadResources();
//   }, [orgId]);

//   useEffect(() => {
//     const loadProjectStatus = async () => {
//       try {
//         const data = await getAllProjectStatus();
//         const activeStatus = data.filter((s) => s.active);
//         setProjectStatusList(activeStatus);
//         const map = {};
//         activeStatus.forEach((s) => {
//           map[s.projectStatusId] = s.projectStatusDesc;
//         });
//         setStatusMap(map);
//       } catch (error) {
//         toast.error("Failed to load project status list");
//       }
//     };

//     loadProjectStatus();
//   }, []);

//   useEffect(() => {
//     const loadCustomers = async () => {
//       try {
//         const data = await fetchCustomerMasterByOrgId(orgId);
//         setCustomers(data || []);
//         const map = {};
//         data.forEach((customer) => {
//           map[customer.customerCode] = customer.name;
//         });
//         setCustomerMap(map);
//       } catch (error) {
//         toast.error("Failed to load customer data");
//       }
//     };

//     if (orgId) {
//       loadCustomers();
//     }
//   }, [orgId]);

//   useEffect(() => {
//     const loadProjectTypes = async () => {
//       try {
//         const data = await fetchProjectTypes(orgId);
//         const activeTypes = data.filter((t) => t.active);
//         setProjectTypes(activeTypes);
//         const map = {};
//         activeTypes.forEach((t) => {
//           map[t.projectTypeId] = t.projectTypeDesc;
//         });
//         setProjectTypeMap(map);
//       } catch (error) {
//         toast.error("Failed to load project types");
//       }
//     };

//     if (orgId) {
//       loadProjectTypes();
//     }
//   }, [orgId]);

//   useEffect(() => {
//     const loadTeams = async () => {
//       try {
//         const data = await getTeamsByOrg(orgId);
//         setTeams(data || []);
//         const map = {};
//         data.forEach((team) => {
//           map[team.teamId] = team.teamName;
//         });
//         setTeamMap(map);
//       } catch (error) {
//         toast.error("Failed to load teams");
//       }
//     };

//     if (orgId) loadTeams();
//   }, [orgId]);

//   const handleDownload = async () => {
//     setIsDownloading(true);
//     try {
//       const workbook = new (await import("xlsx")).utils.book_new();
//       const worksheetData = [
//         [
//           "Project ID",
//           "Title",
//           "Description",
//           "Tags",
//           "Start Date",
//           "End Date",
//           "Client",
//           "Type",
//           "User ID",
//           "Team Assigned",
//           "Status",
//           "Category",
//           "Comments",
//           "Created On Date",
//           "Created On Time",
//           "Created By",
//           "Salesperson Code",
//           "Project Manager",
//         ],
//         ...filteredProjects.map((project) => [
//           project.projectId || "",
//           project.prTitle || "",
//           project.prDescription || "",
//           project.prTags || "",
//           project.prStartDate
//             ? moment(project.prStartDate).format("YYYY-MM-DD")
//             : "",
//           project.prEndDate
//             ? moment(project.prEndDate).format("YYYY-MM-DD")
//             : "",
//           formatWithId(customerMap[project.prClient], project.prClient),
//           formatWithId(projectTypeMap[project.prTypes], project.prTypes),
//           formatWithId(resourceMap[project.usersId], project.usersId),
//           formatWithId(teamMap[project.teamAssigned], project.teamAssigned),
//           formatWithId(statusMap[project.projectStatus], project.projectStatus),
//           project.projectCategory || "",
//           project.comments || "",
//           project.createdOnDate
//             ? moment(project.createdOnDate).format("YYYY-MM-DD")
//             : "",
//           project.createdOnTime || "",
//           formatWithId(resourceMap[project.createdBy], project.createdBy),
//           formatWithId(
//             resourceMap[project.salespersonCode],
//             project.salespersonCode,
//           ),
//           formatWithId(
//             resourceMap[project.currentProjectManager],
//             project.currentProjectManager,
//           ),
//         ]),
//       ];

//       const worksheet = (await import("xlsx")).utils.aoa_to_sheet(
//         worksheetData,
//       );
//       (await import("xlsx")).utils.book_append_sheet(
//         workbook,
//         worksheet,
//         "Projects",
//       );
//       (await import("xlsx")).writeFile(
//         workbook,
//         `Projects_${orgId}_${moment().format("YYYYMMDD_HHmmss")}.xlsx`,
//       );
//       toast.success("Projects data download started!");
//     } catch (error) {
//       console.error("Download error:", error);
//       toast.error(`🦄 Download failed: ${error.message}`);
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   const handleEditClick = () => {
//     setShowEditModal(true);
//   };

//   const handleCloseEditModal = () => {
//     setShowEditModal(false);
//     setSelectedProjectId("");
//     setProjectData({
//       prTitle: "",
//       prDescription: "",
//       prTags: "",
//       prStartDate: "",
//       prEndDate: "",
//       prClient: "",
//       prTypes: "",
//       teamAssigned: "",
//       projectStatus: "",
//       projectCategory: "",
//       comments: "",
//       salespersonCode: "",
//       currentProjectManager: "",
//     });
//   };

//   const handleProjectSelect = async (projectId) => {
//     setSelectedProjectId(projectId);
//     try {
//       setIsLoading(true);
//       const data = await fetchProjectDetails(projectId);
//       setProjectData({
//         prTitle: data.prTitle || "",
//         prDescription: data.prDescription || "",
//         prTags: data.prTags || "",
//         prStartDate: data.prStartDate
//           ? moment(data.prStartDate).format("YYYY-MM-DD")
//           : "",
//         prEndDate: data.prEndDate
//           ? moment(data.prEndDate).format("YYYY-MM-DD")
//           : "",
//         prClient: data.prClient || "",
//         prTypes: data.prTypes || "",
//         teamAssigned: data.teamAssigned || "",
//         projectStatus: data.projectStatus || "",
//         projectCategory: data.projectCategory || "",
//         comments: data.comments || "",
//         salespersonCode: data.salespersonCode || "",
//         currentProjectManager: data.currentProjectManager || "",
//       });
//     } catch (error) {
//       toast.error(`🦄 Error fetching project details`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setProjectData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedProjectId) {
//       toast.error("Please select a project");
//       return;
//     }

//     try {
//       setIsLoading(true);
//       await updateProject(selectedProjectId, projectData);
//       toast.success("Project updated successfully!");

//       const data = isAdmin
//         ? await fetchProjectsByOrg(orgId)
//         : await fetchProjectsByTeamMember(orgId, userId);

//       setProjects(data || []);
//       handleCloseEditModal();
//     } catch (error) {
//       toast.error(`🦄 Error updating project: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const statusOptions = useMemo(() => {
//     return projectStatusList
//       .map((s) => ({
//         value: s.projectStatusId,
//         label: s.projectStatusDesc,
//       }))
//       .sort((a, b) => a.label.localeCompare(b.label));
//   }, [projectStatusList]);

//   const customerOptions = useMemo(() => {
//     return customers
//       .map((c) => ({
//         value: c.customerCode,
//         label: c.name,
//       }))
//       .sort((a, b) => a.label.localeCompare(b.label));
//   }, [customers]);

//   const typeOptions = useMemo(() => {
//     return projectTypes
//       .map((t) => ({
//         value: t.projectTypeId,
//         label: t.projectTypeDesc,
//       }))
//       .sort((a, b) => a.label.localeCompare(b.label));
//   }, [projectTypes]);

//   const resourceOptions = useMemo(() => {
//     return resources
//       .map((r) => ({
//         value: r.resourceId,
//         label: r.name,
//       }))
//       .sort((a, b) => a.label.localeCompare(b.label));
//   }, [resources]);

//   useEffect(() => {
//     localStorage.setItem(
//       "projectVisibleFilters",
//       JSON.stringify(visibleFilters),
//     );
//   }, [visibleFilters]);

//   useEffect(() => {
//     localStorage.setItem("projectColumnOrder", JSON.stringify(columnOrder));
//   }, [columnOrder]);

//   // Reorder columns function
//   const reorderColumns = (fromIndex, toIndex) => {
//     const newOrder = [...columnOrder];
//     const [movedItem] = newOrder.splice(fromIndex, 1);
//     newOrder.splice(toIndex, 0, movedItem);
//     setColumnOrder(newOrder);
//   };

//   // Draggable Header Component - defined inside component to access reorderColumns
//   const DraggableHeader = ({ column, index, children }) => {
//     const [{ isDragging }, drag] = useDrag({
//       type: "COLUMN",
//       item: { index, column },
//       collect: (monitor) => ({
//         isDragging: monitor.isDragging(),
//       }),
//     });

//     const [, drop] = useDrop({
//       accept: "COLUMN",
//       hover: (item) => {
//         if (item.index !== index) {
//           reorderColumns(item.index, index);
//           item.index = index;
//         }
//       },
//     });

//     return (
//       <th
//         ref={(node) => drag(drop(node))}
//         style={{
//           cursor: "move",
//           opacity: isDragging ? 0.5 : 1,
//           backgroundColor: isDragging ? "#f0f0f0" : "inherit",
//           userSelect: "none",
//         }}
//       >
//         {children}
//       </th>
//     );
//   };

//   // Define column configurations
//   const columnConfig = {
//     index: {
//       label: "#",
//       render: (project, index) => <td key="index">{index + 1}</td>,
//       sortable: false,
//     },
//     projectId: {
//       label: "Project ID",
//       render: (project, index) => (
//         <td
//           key="projectId"
//           style={{ cursor: "pointer", color: "#007bff" }}
//           onClick={() => navigate(`/project/${project.projectId}`)}
//         >
//           {project.projectId}
//         </td>
//       ),
//       sortable: false,
//     },
//     title: {
//       label: "Title",
//       render: (project) => <td key="title">{project.prTitle}</td>,
//       sortable: false,
//     },
//     description: {
//       label: "Description",
//       render: (project) => <td key="description">{project.prDescription}</td>,
//       sortable: false,
//     },
//     tags: {
//       label: "Tags",
//       render: (project) => <td key="tags">{project.prTags}</td>,
//       sortable: false,
//     },
//     startDate: {
//       label: "Start Date",
//       render: (project) => (
//         <td key="startDate">
//           {project.prStartDate
//             ? moment(project.prStartDate).format("L")
//             : "N/A"}
//         </td>
//       ),
//       sortable: true,
//       sortKey: "prStartDate",
//     },
//     endDate: {
//       label: "End Date",
//       render: (project) => (
//         <td key="endDate">
//           {project.prEndDate ? moment(project.prEndDate).format("L") : "N/A"}
//         </td>
//       ),
//       sortable: true,
//       sortKey: "prEndDate",
//     },
//     client: {
//       label: "Client",
//       render: (project) => (
//         <td key="client">
//           {formatWithId(customerMap[project.prClient], project.prClient) ||
//             "N/A"}
//         </td>
//       ),
//       sortable: false,
//     },
//     type: {
//       label: "Type",
//       render: (project) => (
//         <td key="type">
//           {formatWithId(projectTypeMap[project.prTypes], project.prTypes) ||
//             "N/A"}
//         </td>
//       ),
//       sortable: false,
//     },
//     team: {
//       label: "Team",
//       render: (project) => (
//         <td key="team">
//           {formatWithId(teamMap[project.teamAssigned], project.teamAssigned)}
//         </td>
//       ),
//       sortable: false,
//     },
//     status: {
//       label: "Status",
//       render: (project) => (
//         <td key="status">
//           {formatWithId(
//             statusMap[project.projectStatus],
//             project.projectStatus,
//           )}
//         </td>
//       ),
//       sortable: false,
//     },
//     category: {
//       label: "Category",
//       render: (project) => <td key="category">{project.projectCategory}</td>,
//       sortable: false,
//     },
//     comments: {
//       label: "Comments",
//       render: (project) => <td key="comments">{project.comments}</td>,
//       sortable: false,
//     },
//     createdOn: {
//       label: "Created On",
//       render: (project) => (
//         <td key="createdOn">
//           {project.createdOnDate
//             ? moment(project.createdOnDate).format("L")
//             : "N/A"}
//           {project.createdOnTime &&
//             ` at ${project.createdOnTime.split(".")[0]}`}
//         </td>
//       ),
//       sortable: true,
//       sortKey: "createdOnDate",
//     },
//     createdBy: {
//       label: "Created By",
//       render: (project) => (
//         <td key="createdBy">{project.createdBy || "N/A"}</td>
//       ),
//       sortable: false,
//     },
//     changedOn: {
//       label: "Changed On",
//       render: (project) => (
//         <td key="changedOn">
//           {project.changedOnDate
//             ? moment(project.changedOnDate).format("L")
//             : "N/A"}
//           {project.changedOnTime &&
//             ` at ${project.changedOnTime.split(".")[0]}`}
//         </td>
//       ),
//       sortable: true,
//       sortKey: "changedOnDate",
//     },
//     changedBy: {
//       label: "Changed By",
//       render: (project) => <td key="changedBy">{project.changedBy}</td>,
//       sortable: false,
//     },
//     salesperson: {
//       label: "Salesperson Code",
//       render: (project) => (
//         <td key="salesperson">
//           {formatWithId(
//             resourceMap[project.salespersonCode],
//             project.salespersonCode,
//           )}
//         </td>
//       ),
//       sortable: false,
//     },
//     projectManager: {
//       label: "Project Manager",
//       render: (project) => (
//         <td key="projectManager">
//           {formatWithId(
//             resourceMap[project.currentProjectManager],
//             project.currentProjectManager,
//           )}
//         </td>
//       ),
//       sortable: false,
//     },
//   };

//   // Active Filters Display Component
//   const ActiveFilters = () => {
//     const allActiveFilters = [
//       ...selectedStatusFilter.map((f) => ({
//         type: "Status",
//         label: f.label,
//         onRemove: () =>
//           setSelectedStatusFilter(
//             selectedStatusFilter.filter((s) => s.value !== f.value),
//           ),
//       })),
//       ...selectedCustomerFilter.map((f) => ({
//         type: "Customer",
//         label: f.label,
//         onRemove: () =>
//           setSelectedCustomerFilter(
//             selectedCustomerFilter.filter((c) => c.value !== f.value),
//           ),
//       })),
//       ...selectedTypeFilter.map((f) => ({
//         type: "Project Type",
//         label: f.label,
//         onRemove: () =>
//           setSelectedTypeFilter(
//             selectedTypeFilter.filter((t) => t.value !== f.value),
//           ),
//       })),
//       ...selectedSalespersonFilter.map((f) => ({
//         type: "Salesperson",
//         label: f.label,
//         onRemove: () =>
//           setSelectedSalespersonFilter(
//             selectedSalespersonFilter.filter((s) => s.value !== f.value),
//           ),
//       })),
//       ...selectedProjectManagerFilter.map((f) => ({
//         type: "Project Manager",
//         label: f.label,
//         onRemove: () =>
//           setSelectedProjectManagerFilter(
//             selectedProjectManagerFilter.filter((m) => m.value !== f.value),
//           ),
//       })),
//     ];

//     if (
//       allActiveFilters.length === 0 &&
//       !selectedCategoryFilter &&
//       !startDateFilter &&
//       !endDateFilter &&
//       !searchTitle &&
//       !searchProjectId
//     ) {
//       return null;
//     }

//     return (
//       <div className="vp-active-filters">
//         <div className="vp-active-filters-label">Active Filters:</div>
//         <div className="vp-active-filters-list">
//           {searchTitle && (
//             <Badge bg="info" className="vp-filter-badge">
//               Search: "{searchTitle}"
//               <FaTimes
//                 className="vp-filter-badge-remove"
//                 onClick={() => setSearchTitle("")}
//               />
//             </Badge>
//           )}
//           {/* Add Project ID badge */}
//           {searchProjectId && (
//             <Badge bg="info" className="vp-filter-badge">
//               Project ID: {searchProjectId}
//               <FaTimes
//                 className="vp-filter-badge-remove"
//                 onClick={() => setSearchProjectId("")}
//               />
//             </Badge>
//           )}
//           {selectedCategoryFilter && (
//             <Badge bg="info" className="vp-filter-badge">
//               Category: {selectedCategoryFilter}
//               <FaTimes
//                 className="vp-filter-badge-remove"
//                 onClick={() => setSelectedCategoryFilter("")}
//               />
//             </Badge>
//           )}
//           {startDateFilter && (
//             <Badge bg="info" className="vp-filter-badge">
//               Start Date ≥ {moment(startDateFilter).format("L")}
//               <FaTimes
//                 className="vp-filter-badge-remove"
//                 onClick={() => setStartDateFilter("")}
//               />
//             </Badge>
//           )}
//           {endDateFilter && (
//             <Badge bg="info" className="vp-filter-badge">
//               End Date ≤ {moment(endDateFilter).format("L")}
//               <FaTimes
//                 className="vp-filter-badge-remove"
//                 onClick={() => setEndDateFilter("")}
//               />
//             </Badge>
//           )}
//           {allActiveFilters.map((filter, idx) => (
//             <Badge key={idx} bg="primary" className="vp-filter-badge">
//               {filter.type}: {filter.label}
//               <FaTimes
//                 className="vp-filter-badge-remove"
//                 onClick={filter.onRemove}
//               />
//             </Badge>
//           ))}
//         </div>
//         {(allActiveFilters.length > 0 ||
//           selectedCategoryFilter ||
//           startDateFilter ||
//           endDateFilter ||
//           searchTitle) && (
//           <Button
//             variant="link"
//             className="vp-clear-all-filters"
//             onClick={() => {
//               setSearchTitle("");
//               setSearchProjectId("");
//               setSelectedStatusFilter([]);
//               setSelectedCustomerFilter([]);
//               setSelectedTypeFilter([]);
//               setSelectedSalespersonFilter([]);
//               setSelectedProjectManagerFilter([]);
//               setSelectedTeamFilter("");
//               setSelectedCategoryFilter("");
//               setSelectedCreatedByFilter("");
//               setStartDateFilter("");
//               setEndDateFilter("");
//             }}
//           >
//             Clear All
//           </Button>
//         )}
//       </div>
//     );
//   };

//   return (
//     <DndProvider backend={HTML5Backend}>
//       <div className="vp-main-content expand">
//         <Container fluid className="vp-list-container">
//           <div
//             className="vp-d-flex vp-justify-content-between vp-align-items-center vp-mb-3"
//             style={{ flexDirection: "column" }}
//           >
//             <div>
//               {" "}
//               <h2 className="vp-list-title" style={{ fontSize: "2.0rem" }}>
//                 View Projects
//               </h2>{" "}
//             </div>
//             <div className="vp-filter-panel">
//               {/* FIRST ROW */}
//               <Row className="g-3 align-items-end">
//                 <div style={{ display: "flex", gap: "16px" }}>
//                   <Col className="d-flex  gap-2">
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">Display Filters</div>
//                       <Select
//                         isMulti
//                         options={filterOptions}
//                         value={filterOptions.filter((f) =>
//                           visibleFilters.includes(f.value),
//                         )}
//                         onChange={(selected) =>
//                           setVisibleFilters(selected.map((s) => s.value))
//                         }
//                         menuPortalTarget={document.body}
//                         menuPosition="fixed"
//                         styles={customSelectStyles}
//                       />
//                     </div>
//                   </Col>
//                   <Button
//                     className="vp-generate-btn"
//                     variant="primary"
//                     onClick={handleDownload}
//                     style={{ marginTop: "16px" }}
//                   >
//                     <FaDownload />
//                   </Button>
//                 </div>

//                 <div
//                   style={{ display: "flex", justifyContent: "space-between" }}
//                 >
//                   <Col md={3} className="gap-2">
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">Search Project</div>
//                       <Form.Control
//                         type="text"
//                         placeholder="Search by title..."
//                         value={searchTitle}
//                         onChange={(e) => setSearchTitle(e.target.value)}
//                       />
//                     </div>
//                   </Col>

//                   {/* Add Project ID filter here */}
//                   {visibleFilters.includes("projectId") && (
//                     <Col md={2}>
//                       <div className="vp-filter-box">
//                         <div className="vp-filter-label">Project ID</div>
//                         <Form.Control
//                           type="text"
//                           placeholder="Search by Project ID..."
//                           value={searchProjectId}
//                           onChange={(e) => setSearchProjectId(e.target.value)}
//                         />
//                       </div>
//                     </Col>
//                   )}

//                   {visibleFilters.includes("status") && (
//                     <Col md={2}>
//                       <div className="vp-filter-box">
//                         <div className="vp-filter-label">Status</div>
//                         <Select
//                           isMulti
//                           options={statusOptions}
//                           value={selectedStatusFilter}
//                           onChange={setSelectedStatusFilter}
//                           styles={customSelectStyles}
//                           menuPortalTarget={document.body}
//                           menuPosition="fixed"
//                           placeholder="Select status..."
//                         />
//                       </div>
//                     </Col>
//                   )}

//                   {visibleFilters.includes("customer") && (
//                     <Col md={2}>
//                       <div className="vp-filter-box">
//                         <div className="vp-filter-label">Customer</div>
//                         <Select
//                           isMulti
//                           options={customerOptions}
//                           value={selectedCustomerFilter}
//                           onChange={setSelectedCustomerFilter}
//                           styles={customSelectStyles}
//                           menuPortalTarget={document.body}
//                           menuPosition="fixed"
//                           placeholder="Select customers..."
//                         />
//                       </div>
//                     </Col>
//                   )}

//                   {visibleFilters.includes("type") && (
//                     <Col md={2}>
//                       <div className="vp-filter-box">
//                         <div className="vp-filter-label">Project Type</div>
//                         <Select
//                           isMulti
//                           options={typeOptions}
//                           value={selectedTypeFilter}
//                           onChange={setSelectedTypeFilter}
//                           styles={customSelectStyles}
//                           menuPortalTarget={document.body}
//                           menuPosition="fixed"
//                           placeholder="Select types..."
//                         />
//                       </div>
//                     </Col>
//                   )}

//                   <Col
//                     md={2}
//                     className="d-flex align-items-end gap-2"
//                     style={{ width: "120px" }}
//                   >
//                     <Button
//                       variant="outline-secondary"
//                       onClick={() => {
//                         setSearchTitle("");
//                         setSearchProjectId("");
//                         setSelectedStatusFilter([]);
//                         setSelectedCustomerFilter([]);
//                         setSelectedTypeFilter([]);
//                         setSelectedSalespersonFilter([]);
//                         setSelectedProjectManagerFilter([]);
//                         setSelectedTeamFilter("");
//                         setSelectedCategoryFilter("");
//                         setSelectedCreatedByFilter("");
//                         setStartDateFilter("");
//                         setEndDateFilter("");
//                       }}
//                     >
//                       Reset
//                     </Button>
//                   </Col>
//                 </div>
//               </Row>

//               {/* SECOND ROW */}
//               <Row className="g-3 mt-1 align-items-end">
//                 {visibleFilters.includes("category") && (
//                   <Col md={2}>
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">Category</div>
//                       <Form.Select
//                         value={selectedCategoryFilter}
//                         onChange={(e) =>
//                           setSelectedCategoryFilter(e.target.value)
//                         }
//                       >
//                         <option value="">All</option>
//                         <option value="Internal">Internal</option>
//                         <option value="External">External</option>
//                       </Form.Select>
//                     </div>
//                   </Col>
//                 )}

//                 {visibleFilters.includes("salesperson") && (
//                   <Col md={2}>
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">Salesperson</div>
//                       <Select
//                         isMulti
//                         options={resourceOptions}
//                         value={selectedSalespersonFilter}
//                         onChange={setSelectedSalespersonFilter}
//                         styles={customSelectStyles}
//                         menuPortalTarget={document.body}
//                         menuPosition="fixed"
//                         placeholder="Select salespersons..."
//                       />
//                     </div>
//                   </Col>
//                 )}

//                 {visibleFilters.includes("manager") && (
//                   <Col md={2}>
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">Project Manager</div>
//                       <Select
//                         isMulti
//                         options={resourceOptions}
//                         value={selectedProjectManagerFilter}
//                         onChange={setSelectedProjectManagerFilter}
//                         styles={customSelectStyles}
//                         menuPortalTarget={document.body}
//                         menuPosition="fixed"
//                         placeholder="Select managers..."
//                       />
//                     </div>
//                   </Col>
//                 )}

//                 {visibleFilters.includes("startDate") && (
//                   <Col md={2}>
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">Start Date</div>
//                       <Form.Control
//                         type="date"
//                         value={startDateFilter}
//                         onChange={(e) => setStartDateFilter(e.target.value)}
//                       />
//                     </div>
//                   </Col>
//                 )}

//                 {visibleFilters.includes("endDate") && (
//                   <Col md={2}>
//                     <div className="vp-filter-box">
//                       <div className="vp-filter-label">End Date</div>
//                       <Form.Control
//                         type="date"
//                         value={endDateFilter}
//                         onChange={(e) => setEndDateFilter(e.target.value)}
//                       />
//                     </div>
//                   </Col>
//                 )}
//               </Row>
//             </div>
//           </div>

//           {/* Active Filters Display */}
//           <ActiveFilters />

//           {projectsLoading ? (
//             <div className="vp-d-flex vp-justify-content-center vp-align-items-center vp-py-5">
//               <Spinner animation="border" variant="primary" />
//               <span className="ms-3">Loading projects...</span>
//             </div>
//           ) : projects.length > 0 ? (
//             <div className="vp-table-wrapper">
//               <div className="vp-table-scroll-container">
//                 <Table bordered hover className="vp-data-table">
//                   <thead>
//                     <tr>
//                       {columnOrder.map((columnKey, index) => {
//                         const column = columnConfig[columnKey];
//                         if (!column) return null;
//                         return (
//                           <DraggableHeader
//                             key={columnKey}
//                             column={columnKey}
//                             index={index}
//                           >
//                             {column.sortable ? (
//                               <div
//                                 style={{
//                                   cursor: "pointer",
//                                   userSelect: "none",
//                                 }}
//                                 onClick={() => handleSort(column.sortKey)}
//                               >
//                                 {column.label} {renderSortArrow(column.sortKey)}
//                               </div>
//                             ) : (
//                               column.label
//                             )}
//                           </DraggableHeader>
//                         );
//                       })}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredProjects.map((project, index) => (
//                       <tr key={index}>
//                         {columnOrder.map((columnKey) => {
//                           const column = columnConfig[columnKey];
//                           if (!column) return null;
//                           return column.render(project, index);
//                         })}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//             </div>
//           ) : (
//             <p className="vp-no-data">No projects found.</p>
//           )}
//         </Container>
//       </div>

//       {/* Edit Project Modal */}
//       <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Project</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmit}>
//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formProjectId">
//                 <Form.Label>Project ID</Form.Label>
//                 <Form.Control
//                   as="select"
//                   value={selectedProjectId}
//                   onChange={(e) => handleProjectSelect(e.target.value)}
//                   required
//                 >
//                   <option value="">Select a project</option>
//                   {projects.map((project) => (
//                     <option key={project.projectId} value={project.projectId}>
//                       {project.projectId} - {project.prTitle}
//                     </option>
//                   ))}
//                 </Form.Control>
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formTitle">
//                 <Form.Label>Project Title</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prTitle"
//                   value={projectData.prTitle}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>

//               <Form.Group as={Col} controlId="formDescription">
//                 <Form.Label>Project Description</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={2}
//                   name="prDescription"
//                   value={projectData.prDescription}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formTags">
//                 <Form.Label>Project Tags</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prTags"
//                   value={projectData.prTags}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>

//               <Form.Group as={Col} controlId="formClient">
//                 <Form.Label>Project Client</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prClient"
//                   value={projectData.prClient}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formStartDate">
//                 <Form.Label>Start Date</Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="prStartDate"
//                   value={projectData.prStartDate}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>

//               <Form.Group as={Col} controlId="formEndDate">
//                 <Form.Label>End Date</Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="prEndDate"
//                   value={projectData.prEndDate}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formType">
//                 <Form.Label>Project Type</Form.Label>
//                 <Form.Control
//                   as="select"
//                   name="prTypes"
//                   value={projectData.prTypes}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">Select Project Type</option>
//                   {projectTypes.map((type) => (
//                     <option key={type.projectTypeId} value={type.projectTypeId}>
//                       {type.projectTypeDesc}
//                     </option>
//                   ))}
//                 </Form.Control>
//               </Form.Group>

//               <Form.Group as={Col} controlId="formTeam">
//                 <Form.Label>Team Assigned</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="teamAssigned"
//                   value={projectData.teamAssigned}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formStatus">
//                 <Form.Label>Project Status</Form.Label>
//                 <Form.Control
//                   as="select"
//                   name="projectStatus"
//                   value={projectData.projectStatus}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">Select Status</option>
//                   {projectStatusList.map((status) => (
//                     <option
//                       key={status.projectStatusId}
//                       value={status.projectStatusId}
//                     >
//                       {status.projectStatusDesc}
//                     </option>
//                   ))}
//                 </Form.Control>
//               </Form.Group>

//               <Form.Group as={Col} controlId="formCategory">
//                 <Form.Label>Project Category</Form.Label>
//                 <Form.Control
//                   as="select"
//                   name="projectCategory"
//                   value={projectData.projectCategory}
//                   onChange={handleInputChange}
//                 >
//                   <option value="">Select Category</option>
//                   <option value="Internal">Internal</option>
//                   <option value="External">External</option>
//                 </Form.Control>
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formComments">
//                 <Form.Label>Comments</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={2}
//                   name="comments"
//                   value={projectData.comments}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Row>

//             <Row className="mb-3">
//               <Form.Group as={Col} controlId="formSalesperson">
//                 <Form.Label>Salesperson Code</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="salespersonCode"
//                   value={projectData.salespersonCode}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>

//               <Form.Group as={Col} controlId="formManager">
//                 <Form.Label>Project Manager</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="currentProjectManager"
//                   value={projectData.currentProjectManager}
//                   onChange={handleInputChange}
//                 />
//               </Form.Group>
//             </Row>

//             <div className="d-flex justify-content-end">
//               <Button
//                 variant="secondary"
//                 onClick={handleCloseEditModal}
//                 className="me-2"
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" type="submit" disabled={isLoading}>
//                 {isLoading ? "Updating..." : "Update Project"}
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </DndProvider>
//   );
// };

// export default ViewProjects;
